import MapContainer from "./MapContainer";
import MapStore from "./MapStore";
export default MapStore(MapContainer);